<ul data-cy="suggestion-dropdown-container" class="container" [class.hidden]="!visible" tabindex="-1" #container>
  <li class="item item-search" [tabindex]="visible ? 0 : -1" #option>
    <u-icon
      [class.clickable]="!!group"
      [class]="'font-icon item-search-icon ' + (group ?? 'clickable')"
      (click)="group ? clearGroup() : null"
      [model]="{ type: 'font', value: group ? 'icon-chevron-left' : 'icon-magnifier' }"
    ></u-icon>

    <div class="item-search-input-container">
      <input class="item-search-input-autocomplete" [tabindex]="visible ? 0 : -1" [(ngModel)]="placeholderValue" />

      <input
        data-cy="suggestion-dropdown-input"
        [tabindex]="visible ? 0 : -1"
        class="item-search-input"
        type="text"
        #input
        [placeholder]="placeholderValue ? '' : defaultPlaceholder"
        [(ngModel)]="query"
        (keydown)="onInputKeyDown($event)"
        (ngModelChange)="onInput()"
      />
    </div>
  </li>

  <li class="item no-result" *ngIf="model?.length === 0" tabindex="0">
    <div class="item-content">
      <h3 class="no-result-title">No Results</h3>
    </div>
  </li>
  <div data-cy="suggestions-dropdown-scrollable" class="scroll-viewport" #list [tabindex]="visible ? 0 : -1">
    <suggestions-dropdown-item
      *ngFor="let item of model || []; index as i; trackBy: trackItems"
      data-cy="suggestion-dropdown-item"
      #option
      class="item"
      [model]="item"
      [selected]="selectedIndex === i"
      (click)="selectedIndex = i; applySelected(); focusSearch()"
    ></suggestions-dropdown-item>
  </div>
</ul>
